module.exports = __webpack_public_path__ + "img/airline_seat_legroom_normal.4318f8f7.svg";